import { Button, Col, Divider, Form, Input, Radio, Row, Table } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useRecoilState } from 'recoil'
import customerApi from '../../api/customer.api'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import { searchValueState } from '../../store/searchValue'
import { userState } from '../../store/user'
import styles from '../../styles/customer.module.scss'

const SendSmsPage = () => {
  const [user, setUser] = useRecoilState(userState)
  const [selectOrderList, setSelectOrderList] = useRecoilState(searchValueState)
  const [isLoading, setIsLoading] = useState(false)

  const [listType, setListType] = useState('manual')
  const [dateType, setDateType] = useState(1)
  const [smsType, setSmsType] = useState(
    user?.role === 'level_1' ? 'kakaoFriend' : 'sms',
  )
  const [recipientList, setRecipientList] = useState([])
  const [depositUserList, setDepositUserList] = useState([])
  const [selectedDepositUserRowKey, setSelectedDepositUserRowKey] = useState([])
  const [selectedDepositUserRow, setSelectedDepositUserRow] = useState([])
  const [purchaseUserList, setPurchaseUserList] = useState([])
  const [selectedPurchaseUserRowKey, setSelectedPurchaseUserRowKey] = useState(
    [],
  )
  const [selectedPurchaseUserRow, setSelectedPurchaseUserRow] = useState([])
  const [sms, setSms] = useState({
    phone: null,
    content: null,
  })

  const dateTypeItems = [
    { label: '1일', value: 1 },
    { label: '2일', value: 2 },
    { label: '4일', value: 4 },
    { label: '7일', value: 7 },
  ]
  const depositRowSelection = {
    selectedRowKeys: selectedDepositUserRowKey,
    onChange: (selectedRowKeys, selectedRows) => {
      if (listType === 'deposit') {
        setSelectedDepositUserRowKey(selectedRowKeys)
        setSelectedDepositUserRow(selectedRows)
      }
    },
  }

  const depositColumns = [
    {
      title: '닉네임',
      // width: 120,
      dataIndex: 'name',
      key: 'name',
      // ellipsis: true
    },
    {
      title: '휴대폰 번호',
      // width: 120,
      dataIndex: 'phone',
      key: 'phone',
      // ellipsis: true
    },
    {
      title: '주문번호',
      // width: 120,
      dataIndex: 'orderId',
      key: 'orderId',
      // ellipsis: true
    },
  ]

  useEffect(() => {
    readUserList('purchase')
  }, [])

  // useEffect(() => {
  //   if (selectOrderList.selectOrderList) {
  //     setRecipientList(selectOrderList.selectOrderList)
  //   }
  //   console.log('selectOrderList', selectOrderList)
  // }, [selectOrderList])

  useEffect(() => {
    changeSmsContentForTemplate()
    if (listType === 'deposit') {
      setSelectedDepositUserRow(depositUserList)
      setSelectedDepositUserRowKey(depositUserList.map((user) => user.orderId))
      setSelectedPurchaseUserRow([])
      setSelectedPurchaseUserRowKey([])
      setRecipientList([])
    } else if (listType === 'purchase') {
      setSelectedPurchaseUserRow(purchaseUserList)
      setSelectedPurchaseUserRowKey(
        purchaseUserList.map((user) => user.orderId),
      )
      setSelectedDepositUserRow([])
      setSelectedDepositUserRowKey([])
      setRecipientList([])
    } else {
      setSelectedDepositUserRow([])
      setSelectedDepositUserRowKey([])
      setSelectedPurchaseUserRow([])
      setSelectedPurchaseUserRowKey([])
    }
  }, [listType])

  useEffect(() => {
    readUserList('deposit')
    changeSmsContentForTemplate()
  }, [dateType])

  /**
   * 회원목록 조회
   */
  const readUserList = async (type = '') => {
    setIsLoading(true)
    try {
      let param = {
        type: type,
      }
      if (type === 'deposit') {
        param['days'] = dateType
      } else if (type === 'purchase') {
        param['days'] = 30
        param['productId'] = 21041
      }
      const res = await customerApi.readAllUserListForSMS(param, user.id)
      if (res.data.code === 200) {
        if (type === 'deposit') {
          setDepositUserList(res.data.result)
          if (listType === 'deposit') {
            setSelectedDepositUserRow(res.data.result)
            setSelectedDepositUserRowKey(
              res.data.result.map((user) => user.orderId),
            )
          }
        } else if (type === 'purchase') {
          setPurchaseUserList(res.data.result)
          if (listType === 'purchase') {
            setSelectedPurchaseUserRow(res.data.result)
            setSelectedPurchaseUserRowKey(
              res.data.result.map((user) => user.orderId),
            )
          }
        }
      } else {
        alert('SMS 대상자를 조회해오는데 실패하였습니다.')
        throw res.data.msg
      }
      setIsLoading(false)
    } catch (error) {
      setIsLoading(false)
      console.log('readUserList read error', error)
    }
  }

  /**
   * 문자전송
   */
  const sendSms = async () => {
    const alertText =
      smsType === 'sms'
        ? '해당 내용으로 SMS 전송을 진행하시겠습니까? 문자 내용 중 "#{변수명}"은 자동으로 치환됩니다.'
        : `해당 내용으로 총 ${recipientList?.length}명에게 카카오 친구톡을 전송하시겠습니까?`
    if (window.confirm(alertText)) {
      setIsLoading(true)
      try {
        let messageList = []
        if (listType === 'manual') {
          for (const recipient of recipientList) {
            const message = {
              targetPhone: recipient.phone,
              crmMessage: sms.content,
            }
            messageList.push(message)
          }
        } else if (listType === 'deposit') {
          for (const user of selectedDepositUserRow) {
            let content = sms.content
            if (content.includes('#{이름}')) {
              content = content.replaceAll('#{이름}', user.name)
            }
            if (content.includes('#{제품명}')) {
              content = content.replaceAll('#{제품명}', user.productName)
            }
            if (content.includes('#{주문번호}')) {
              content = content.replaceAll('#{주문번호}', user.orderId)
            }
            if (content.includes('#{입금금액}')) {
              content = content.replaceAll(
                '#{입금금액}',
                user.totalPrice.toLocaleString() + '원',
              )
            }
            const message = {
              userId: user.id,
              targetType: 'ORDER',
              targetId: user.orderId,
              targetName: user.name,
              targetPhone: user.phone,
              crmTitle: `ORDER_DEPOSIT_REQUEST_${dateType}`,
              crmMessage: content,
            }
            messageList.push(message)
          }
        } else if (listType === 'purchase') {
          for (const user of selectedPurchaseUserRow) {
            let content = sms.content
            if (content.includes('#{이름}')) {
              content = content.replaceAll('#{이름}', user.name)
            }
            const message = {
              userId: user.id,
              targetType: 'ORDER',
              targetId: user.orderId,
              targetName: user.name,
              targetPhone: user.phone,
              crmTitle: `ORDER_DELIVERY_COMPLETE_FOR_21041`,
              crmMessage: content,
            }
            messageList.push(message)
          }
        }
        let res
        if (smsType === 'kakaoFriend') {
          const param = {
            targetPhoneList: recipientList?.map(
              (recipient) => recipient?.phone,
            ),
            content: sms.content,
          }
          res = await pushApi.kakaoForFriend(param, user.id)
        } else {
          res = await pushApi.smsSend(messageList, user.id)
        }
        if (res.data.code === 200) {
          alert(
            `${
              smsType === 'kakaoFriend' ? '카카오 친구톡을' : 'SMS를'
            } 성공적으로 전송하였습니다.`,
          )
          setSms({ ...sms, phone: null })
          changeSmsContentForTemplate()
          setRecipientList([])
          setSelectOrderList({
            ...selectOrderList,
            selectOrderList: [],
          })
          readUserList('deposit')
          readUserList('purchase')
        } else {
          throw res.data.msg
        }
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.log('sendSms send error', error)
        alert(error)
      }
    }
  }

  /**
   * 수신번호 추가
   */
  const addPhone = () => {
    if (sms.phone === null || sms.phone === '') {
      alert('입력된 번호가 없습니다.')
    } else {
      const hasPhone = recipientList?.some(
        (recipientObj) => recipientObj?.phone === sms.phone,
      )
      if (hasPhone) {
        alert('이미 추가된 번호입니다.')
        setSms({ ...sms, phone: null })
      } else {
        let currList = [...recipientList]
        const order = {
          phone: sms.phone,
        }
        currList.push(order)
        setRecipientList(currList)
        setSms({ ...sms, phone: null })
      }
    }
  }

  /**
   * 문자 템플릿 불러오기
   */
  const changeSmsContentForTemplate = () => {
    if (listType === 'deposit') {
      switch (dateType) {
        case 1:
          setSms({
            ...sms,
            content:
              '안녕하세요 #{이름}님\n' +
              '어제 주문하신 #{제품명} 상품 입금이 아직 대기 상태여서 연락드립니다.\n\n' +
              '입금을 완료하시면 바로 출고되어 1~2일 내로 제품을 받아보실 수 있습니다.\n\n' +
              '혹시 결제 중 어려운 점이 있다면 언제든 편하게 문의주세요. 진심을 다해 도와드리겠습니다.\n\n' +
              '빠른 배송과 최고의 서비스를 제공하기 위해 언제나 노력하겠습니다.\n' +
              '감사합니다.\n\n' +
              '[주문결제상담] 1899-2879\n[상담시간] 평일 오전 10시 ~ 오후 6시\n\n' +
              '주문번호: #{주문번호}\n' +
              '입금금액: #{입금금액}\n' +
              '입금계좌: 농협은행[351-1259-7186-23]\n예금주: 주식회사 하우투약',
          })
          break
        case 2:
          setSms({
            ...sms,
            content:
              '안녕하세요 #{이름}님\n' +
              '이틀 전 #{제품명} 주문해 주셨는데요! 아직 입금 확인이 안돼서 연락드립니다.\n\n' +
              '결제가 완료되어야 배송을 진행할 수 있는데요. 아직 결제 확인이 안돼서 상품 출고를 위해 대기 중입니다. 입금되면 바로 출고되어 1~2일 내로 제품을 받아보실 수 있습니다.\n\n' +
              '결제가 어려우시거나 문의사항이 있으시면 언제든 편하게 문의주시면 친절하게 도와드리겠습니다.\n\n' +
              '빠른 배송과 최고의 서비스를 제공하기 위해 언제나 노력하겠습니다.\n' +
              '감사합니다.\n\n' +
              '[주문결제상담] 1899-2879\n[상담시간] 평일 오전 10시 ~ 오후 6시\n\n' +
              '주문번호: #{주문번호}\n' +
              '입금금액: #{입금금액}\n' +
              '입금계좌: 농협은행[351-1259-7186-23]\n예금주: 주식회사 하우투약',
          })
          break
        case 4:
          setSms({
            ...sms,
            content:
              '안녕하세요 #{이름}님\n' +
              '며칠 전 주문하셨던 #{제품명} 상품이 아직 입금 확인이 되지 않아서 연락드립니다.\n\n' +
              '혹여나 결제가 마무리되어 배송 중이라 여기시고 입금을 잊으셨거나\n' +
              '결제에 어려움을 겪고 계시진 않나 걱정되는 마음에 연락드립니다.\n\n' +
              '결제 과정에 어려움이 있다면 언제든 편하게 문의주시면 친절하게 도와드리겠습니다.\n\n' +
              '빠른 배송과 최고의 서비스를 제공하기 위해 언제나 노력하겠습니다.\n' +
              '감사합니다.\n\n' +
              '[주문결제상담] 1899-2879\n[상담시간] 평일 오전 10시 ~ 오후 6시\n\n' +
              '주문번호: #{주문번호}\n' +
              '입금금액: #{입금금액}\n' +
              '입금계좌: 농협은행[351-1259-7186-23]\n예금주: 주식회사 하우투약',
          })
          break
        case 7:
          setSms({
            ...sms,
            content:
              '안녕하세요 #{이름}님\n' +
              '일주일 전 주문하셨던 #{제품명} 상품 기억하고 계시나요?\n\n' +
              '주문 접수는 완료되었으나, 아직 입금이 완료되지 않아서 출고를 위해 대기중입니다!\n\n' +
              '아래 계좌 정보로 입금해주시면\n' +
              '바로 출고되어 1~2일 내로 제품을 받아 보실 수 있습니다.\n\n' +
              '결제가 어려우시거나 결제 수단을 변경하고 싶으시다면 언제든 연락주세요!\n언제든 최선을 다하여 도와드리겠습니다.\n감사합니다.\n\n' +
              '[주문결제상담] 1899-2879\n[상담시간] 평일 오전 10시 ~ 오후 6시\n\n' +
              '주문번호: #{주문번호}\n' +
              '입금금액: #{입금금액}\n' +
              '입금계좌: 농협은행[351-1259-7186-23]\n예금주: 주식회사 하우투약',
          })
          break
      }
    } else if (listType === 'purchase') {
      setSms({
        ...sms,
        content:
          '안녕하세요 #{이름}님\n' +
          '당신의 영양제 담당 약사 이진한입니다. 당신의 영양제와 함께 건강한 나날들 보내고 계시나요?\n\n' +
          '한 달 전 구매하셨던 프로메드 더블랙맥주 효모환 잘 섭취하고 계신지 안부 차 연락드립니다.\n\n' +
          '오늘은 우리 몸의 세포주기에 대한 이야기를 잠깐 들려드릴까 합니다.\n' +
          '우리 몸의 세포 주기는 100일로 3개월 이상 꾸준하게 섭취했을 때 기대하신 바를 몸에서 느끼기 시작합니다.\n\n' +
          '저 또한 영양제 섭취를 까먹는 날이 있곤 합니다. 하지만 포기하지 않고 꾸준하게 섭취 하는 습관을 들이셔서 구매하신 영양제가 꼭 #{이름}님 건강에 큰 도움이 되었으면 좋겠습니다.\n\n' +
          '건강 개선에 대한 영양 상담을 원하시거나 영양제에 대한 궁금한 점이 있으시다면 언제든 편하게 당신의 영양제로 문의주세요!\n\n' +
          '감사합니다.\n\n' +
          '[영양상담문의] 1899-2879\n[상담시간] 평일 오전 10시 ~ 오후 6시',
      })
    } else {
      setSms({ ...sms, content: null })
    }
  }

  /**
   * 문자 전송 버튼 disabled
   */
  const disabledSendBtn = () => {
    if (listType === 'manual') {
      return !(recipientList?.length > 0 && sms.content !== null)
    } else if (listType === 'deposit') {
      return !(selectedDepositUserRowKey?.length > 0 && sms.content !== null)
    } else if (listType === 'purchase') {
      return !(selectedPurchaseUserRowKey?.length > 0 && sms.content !== null)
    }
  }

  /**
   * 문자 전송 취소
   */
  const cancelSendSms = () => {
    if (
      window.confirm(
        '지금까지 작성했던 내용들이 사라집니다. SMS 전송을 취소하시겠습니까?',
      )
    ) {
      setSms({
        phone: null,
        content: null,
      })
      setRecipientList([])
      setSelectOrderList({
        ...selectOrderList,
        selectOrderList: [],
      })
    }
  }

  return (
    <>
      <ContentHeader title="문자 전송" />
      <Row justify="space-between" wrap={false} id={`call-purchase-body`}>
        <Col span={8}>
          <div
            className={`${styles['product-register-wrap']}`}
            style={{ marginTop: 21, marginRight: 12 }}
          >
            {/*번호 설정*/}
            <Row
              className={`${styles['product-register-border-box']} ${styles['send-sms-border-box']}`}
              align="middle"
              wrap={false}
              style={{ borderBottom: 0 }}
            >
              <img
                className={`${styles['sms-list-check']}`}
                src={`${process.env.REACT_APP_HOST}/assets/icon/customer/${
                  listType === 'manual' ? 'checkActive' : 'check'
                }.png`}
                onClick={() => setListType('manual')}
              />
              <span
                className={`${styles['product-register-box-title']}`}
                onClick={() => setListType('manual')}
                style={{ cursor: 'pointer' }}
              >
                번호 설정
              </span>
            </Row>
            <div
              className={`${styles['product-register-border-box']}`}
              style={{ padding: '25px 25px 40px', height: 'fit-content' }}
            >
              <Form.Item
                className={`${styles['member-send-sms-list-form-wrap']}`}
                label="발신번호"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input value="1899-2879" disabled />
              </Form.Item>
              <Form.Item
                className={`${styles['member-send-sms-list-form-wrap']}`}
                label="수신번호 추가"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Row justify="space-between" align="middle" wrap={false}>
                  <Input
                    name="phone"
                    value={sms.phone}
                    onChange={(e) => {
                      if (
                        e.target.value === '' ||
                        (/^[0-9\b]+$/.test(e.target.value) &&
                          e.target.value?.length <= 11)
                      ) {
                        setSms({ ...sms, [e.target.name]: e.target.value })
                      }
                    }}
                    onPressEnter={addPhone}
                    placeholder="( - ) 없이 입력해주세요"
                    style={{ width: 'auto' }}
                  />
                  <img
                    className={`${styles['member-send-sms-add-list']}`}
                    src={`${process.env.REACT_APP_HOST}/assets/icon/common/plus.png`}
                    onClick={addPhone}
                  />
                </Row>
              </Form.Item>
              <Form.Item
                className={`${styles['member-send-sms-list-form-wrap']}`}
                label="수신 목록"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                {recipientList?.length !== 0 && (
                  <>
                    {recipientList.map((recipient, idx) => (
                      <div key={idx}>{recipient.phone}</div>
                    ))}
                  </>
                )}
              </Form.Item>
            </div>

            {/*무통장입금 미입금*/}
            {smsType === 'sms' && (
              <>
                <Row
                  className={`${styles['product-register-border-box']} ${styles['send-sms-border-box']}`}
                  align="middle"
                  wrap={false}
                  style={{ marginTop: 24, borderBottom: 0 }}
                >
                  <img
                    className={`${styles['sms-list-check']}`}
                    src={`${process.env.REACT_APP_HOST}/assets/icon/customer/${
                      listType === 'deposit' ? 'checkActive' : 'check'
                    }.png`}
                    onClick={() => setListType('deposit')}
                  />
                  <span
                    className={`${styles['product-register-box-title']}`}
                    onClick={() => setListType('deposit')}
                    style={{ cursor: 'pointer' }}
                  >
                    무통장입금 미입금
                  </span>
                </Row>
                <div
                  className={`${styles['product-register-border-box']}`}
                  style={{ padding: '25px 25px 40px', height: 'fit-content' }}
                >
                  <Form.Item
                    className={`${styles['member-send-sms-list-form-wrap']}`}
                    label="발신번호"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Input value="1899-2879" disabled />
                  </Form.Item>
                  <Form.Item
                    className={`${styles['member-send-sms-list-form-wrap']}`}
                    label="수신인 설정"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Row align="middle" gutter={[0, 8]}>
                      <p className={`${styles['member-send-sms-sub-label']}`}>
                        주문 후
                      </p>
                      <Radio.Group
                        className={`${styles['member-send-sms-radio-wrap']}`}
                        options={dateTypeItems}
                        name="days"
                        value={dateType}
                        onChange={(e) => {
                          setDateType(e.target.value)
                          if (listType !== 'deposit') {
                            setListType('deposit')
                          }
                        }}
                      />
                    </Row>
                  </Form.Item>
                  <Row
                    justify="space-between"
                    align="middle"
                    className={`${styles['deposit-user-list-title-wrap']}`}
                  >
                    <p>미전송건({selectedDepositUserRowKey?.length}건)</p>
                    <p>{dayjs().format('YYYY.MM.DD')} 금일 기준</p>
                  </Row>
                  <Table
                    className={`${styles['member-send-sms-table-wrap']}`}
                    rowSelection={depositRowSelection}
                    columns={depositColumns}
                    dataSource={depositUserList}
                    loading={isLoading}
                    bordered
                    size="small"
                    rowKey="orderId"
                    rowClassName={`${styles['coupon-table-row']}`}
                    scroll={{ x: 'max-content', y: 'calc(220px - 48px)' }}
                    tableLayout={'auto'}
                    pagination={false}
                  />
                </div>
              </>
            )}
          </div>
        </Col>
        <Col span={16}>
          <div
            className={`${styles['product-register-wrap']}`}
            style={{ marginTop: 21, marginLeft: 12, marginRight: 30 }}
          >
            <Row
              className={`${styles['product-register-border-box']} ${styles['send-sms-border-box']}`}
              align="middle"
              wrap={false}
              style={{ borderBottom: 0, padding: '0 20px' }}
            >
              {(user?.role === 'super_admin' || user?.role === 'level_1') && (
                <div
                  className={`${styles['member-send-sms-content-title-wrap']} ${smsType === 'kakaoFriend' ? styles.select : ''}`}
                  onClick={() => setSmsType('kakaoFriend')}
                >
                  카카오 친구톡
                </div>
              )}
              <div
                className={`${styles['member-send-sms-content-title-wrap']} ${smsType === 'sms' ? styles.select : ''}`}
                onClick={() => setSmsType('sms')}
              >
                일반 문자
              </div>
            </Row>
            <div
              className={`${styles['product-register-border-box']}`}
              style={{ padding: '27px 20px 26px 27px', height: 'fit-content' }}
            >
              <Form.Item
                className={`${styles['member-send-sms-list-form-wrap']}`}
                label="문자 내용"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <Input.TextArea
                  value={sms.content}
                  placeholder="문자 내용을 입력해주세요"
                  maxLength={1000}
                  onChange={(e) => setSms({ ...sms, content: e.target.value })}
                />
              </Form.Item>
              <Divider
                className={`${styles['product-register-form-input-divider']}`}
                style={{ marginTop: 30 }}
              />
              <Row justify="end" align="middle" wrap={false}>
                <Button
                  className={`${styles['member-send-sms-button']} ${styles.send}`}
                  loading={isLoading}
                  disabled={disabledSendBtn()}
                  onClick={sendSms}
                >
                  {isLoading ? '' : '전송'}
                </Button>
                <Button
                  className={`${styles['member-send-sms-button']} ${styles.cancel}`}
                  disabled={isLoading}
                  onClick={cancelSendSms}
                >
                  취소
                </Button>
              </Row>
            </div>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default SendSmsPage
